import invariant from 'tiny-invariant'

export const sessionId = crypto.randomUUID()

/**
 * Debug logs are enabled automatically on Vercel Preview deployments so QA and
 * stakeholders can inspect notification activity from the browser console
 * without a local rebuild. Production stays silent.
 *
 * - `VERCEL_ENV` is inlined for Vite apps (studio, lumo) via
 *   `EnvironmentPlugin('all')` in their `vite.config.mts`.
 * - `NEXT_PUBLIC_VERCEL_ENV` is auto-exposed by Vercel for Next.js client
 *   bundles.
 *
 * Override locally by setting either env var to `preview`.
 */
export const debug =
  process.env.VERCEL_ENV === 'preview' || process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function log(...args: any[]) {
  // eslint-disable-next-line no-console
  console.log('[🔔 CF Notifications] -', ...args)
}

export const baseUrl =
  process.env.VITE_RPC_NOTIFICATION_SERVICE_URL ||
  process.env.NEXT_PUBLIC_RPC_NOTIFICATION_SERVICE_URL
invariant(
  baseUrl,
  'VITE_RPC_NOTIFICATION_SERVICE_URL or NEXT_PUBLIC_RPC_NOTIFICATION_SERVICE_URL environment variable is required for using notifications',
)
